@if (loadConfiguration) {
  <div
    class="config-page-container config-page-flex"
    [ngClass]="sidenavCollapsed ? 'sidenav-collapsed' : 'sidenav-expanded'"
  >
    <escalation-order-config-card
      [escalationType]="'soc'"
      [escalationTitle]="'Security Operations Center (SOC)'"
      [escalationIcon]="'security'"
      [repository]="managedServicesRepository"
      [configurationService]="managedServicesConfigService"
      [canAdd]="canAdd"
      [canEdit]="canEdit"
      [canDelete]="canDelete"
    ></escalation-order-config-card>
    <escalation-order-config-card
      [escalationType]="'noc'"
      [escalationTitle]="'Network Operations Center (NOC)'"
      [escalationIcon]="'lan'"
      [repository]="managedServicesRepository"
      [configurationService]="managedServicesConfigService"
      [canAdd]="canAdd"
      [canEdit]="canEdit"
      [canDelete]="canDelete"
    ></escalation-order-config-card>
    <msp-config-module-approval
      class="config-page-container__module-approval"
      [canEdit]="canEdit"
    ></msp-config-module-approval>
  </div>
}
